<div class="calendar-holder">
  @if(isBrowser && isReady) {
    <mat-calendar
      #calendar
      [minDate]="today"
      [maxDate]="maxDate"
      [dateClass]="dateClass"
      [dateFilter]="dateFilter"
      (selectedChange)="onSelect($event)">
    </mat-calendar>
  } @else {
    <div class="skeleton-loader"></div>
  }
</div>